import React, { Suspense } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { lazyWithRetry } from 'lib/utilityFunctions';
import { getSeason } from 'a/hub/selectors';
import { SEASON } from 'a/hub/data/constants';
import { reportSessionRefresh, reportLogOut } from 'a/actions/searchlightActions';
import { closeSessionTimeoutModal } from 'a/hub/actions/modalSystemActions';
import { getOpenModalConfig } from 'a/hub/selectors/modalSystemSelectors';

import AnimatedModal from './AnimatedModal';

const SESSION_TIMEOUT_MODALS = {
  [SEASON.GRADE_K_1]: lazyWithRetry(() => import('a/hub/components/SessionTimeoutModal')),
  [SEASON.GRADE_2_3]: lazyWithRetry(() => import('a/hub/components/SessionTimeoutModal')),
  [SEASON.GRADE_4_5]: lazyWithRetry(() => import('a/hub/components/SessionTimeoutModal')),
};

const SessionTimeoutModal = () => {
  const dispatch = useDispatch();
  const season = useSelector(getSeason);
  const { origin = 'unknown origin' } = useSelector(getOpenModalConfig) || {};
  const gameId = useSelector(state => state.selectedActivity.activity);

  const ModalComponent = SESSION_TIMEOUT_MODALS[season] || SESSION_TIMEOUT_MODALS[SEASON.GRADE_K_1];

  const onCancel = () => {
    // Reporting goes here
    dispatch(reportSessionRefresh(gameId));
    dispatch(closeSessionTimeoutModal());
  };

  const onLogout = () => {
    dispatch(reportLogOut(origin));
  };

  return (
    <Suspense fallback={null}>
      <AnimatedModal>
        <ModalComponent
          onCancel={onCancel}
          onLogout={onLogout}
        />
      </AnimatedModal>
    </Suspense>
  );
};

export default SessionTimeoutModal;
